"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FooterLink(_ref) {
  var children = _ref.children;
  return _react.default.createElement("li", null, children);
}

FooterLink.propTypes = {
  /** {<Link>} */
  children: _propTypes.any.isRequired
};
FooterLink.displayName = 'Footer.Link';
var _default = FooterLink;
exports.default = _default;
FooterLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Footer.Link",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{<Link>}"
    }
  }
};